import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";
import UnorderedList from "../layouts/bodyLayouts/helpers/UnorderedList";
import Links from "../components/Links";
// import Waiver from "../../src/assets/img/1918/waiver.jpg";
import Attention from "../../src/assets/img/1918/irise_attention.png";

const LittleEyeProvider_Content = [
  {
      format: bodyHelperTypes.paragraphs,
      order: 10,
      content: [
          <div style={{textAlign: "center"}}>
              <a href="https://us06web.zoom.us/meeting/register/EcV98VonRAGKFN2BYByWMw#/registration"><img src={Attention} alt="1915i Waiver" width="800" height="600"></img></a>
          </div>

      ]

  },

  {
    format: bodyHelperTypes.title,
    order: 11,
    content:
      "Deliver Meaningful, Medicaid-Funded Services to Kentuckians with Serious Mental Illness",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 20,
    content: [
      <></>,
      <>
        The <b>The 1915(i) RISE Initiative</b> (Recovery, Independence, Support,
        and Engagement) offers Medicaid-enrolled organizations and agencies the
        opportunity to deliver <b>home and community-based services (HCBS)</b>{" "}
        to adults living with <b>serious mental illness (SMI)</b> or{" "}
        <b>SMI with co-occurring substance use disorder (SUD)</b> across
        Kentucky.
      </>,
      <>
        Through this initiative, eligible providers can deliver one or more of{" "}
        <b>10 Medicaid-reimbursed services</b> that empower individuals to live
        safely, independently, and with dignity in the community.
      </>,
      <>
        This page includes essential information on:
        <ul>
          <li>Provider eligibility.</li>
          <li>Required trainings and certification.</li>
          <li>Enrollment process and timeline.</li>
          <li>Technical assistance and support resources.</li>
        </ul>
      </>,
      <>
        <b>Who Can Become a 1915(i) RISE Provider?</b>
        <br />
        Providers will come from a wide variety of fields and throughout the
        state. To deliver services under the 1915(i) RISE Initiative, your
        organization must:
        <ul>
          <li>
            Meet provider-specific qualifications outlined in regulation{" "}
            <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/015/">
              907 KAR 16:015
            </a>
          </li>
          <li>
            Complete a{" "}
            <b>
              1915(i) RISE Certification and Training Process managed by the
              Department for Behavioral Health, Developmental and Intellectual
              Disabilities (DBHDID)
            </b>
            .
          </li>
          <li>
            Submit an enrollment application through the{" "}
            <b>Medicaid Provider Portal Application (MPPA)</b>.{" "}
          </li>
          <li>Be enrolled in Kentucky Medicaid.</li>
          <li>Enroll in Therap Provider Intake System.</li>
        </ul>
      </>,
      <>
        <b>Note:</b>Individual practitioners must be affiliated with an enrolled
        Medicaid provider to 1915(i) RISE services.
      </>,
      <>
        <b>What Services Can Providers Offer?</b>
        <br />
        Certified providers may choose to deliver one or more of the following
        services:
        <ol>
          <li>Assistive Technology</li>
          <li>Case Management*</li>
          <li>Housing and Tenancy Supports</li>
          <li>Medication Management</li>
          <li>Planned Respite for Caregivers</li>
          <li>Supervised Residential Care</li>
          <li>In-Home Independent Living Supports</li>
          <li>Supported Education</li>
          <li>Supported Employment</li>
          <li>Transportation (Non-Medical)</li>
        </ol>
      </>,
      <>
        *Conflict-free case management is a requirement of the 1915(i) RISE.
        Conflict-free case management means that the assessment and coordination
        of services are separate from the actual delivery of those services. As
        such, case management providers may not provide additional 1915(i) RISE
        services.
      </>,
      <>
        Each service has specific requirements for staff qualifications,
        documentation, and service delivery as outlined in{" "}
        <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/015/">
          907 KAR 16:015
        </a>{" "}
        and{" "}
        <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/020/">
          907 KAR 16:020
        </a>
        .
      </>,
      <>
        <b>Step-by-Step Provider Certification Process </b>
        <br />
        All providers must complete a multi-step certification and onboarding
        process before they may begin delivering services or submitting claims.
      </>,
      <>
        <b>Step 1: Access Provider Resources</b>
        <br />

        <ul>
          <li>Review provider qualifications above and on the Provider FAQ.</li>
          <li>
            Access the full list of services and regulations above and on the
            Provider FAQ.
          </li>
          <li>
            Access the self-registration link to the{" "}
            <a href="https://learningmanager.adobe.com/accountiplogin?ipId=18176&accesskey=4cvijumaahm1t">
              Adobe Learning Management (ALM) System.
            </a>
          </li>
          Please see the ALM video below for additional assistance with account
          creation.
          <br />
          {/* <video className="container" width="650" height="400" controls >
                        <source src={RiseReg} type="video/mp4" />
                    </video> */}
          <a href="https://youtu.be/FxI544_U-2M ">
            Adobe Learning Manager 1915i RISE Registration
          </a>
          <br />
          <br />
          <li>
            For existing users, email{" "}
            <a href="mailto:1915iRISEprovider@ky.gov ">
              1915iRISEprovider@ky.gov{" "}
            </a>
            for course access.
          </li>
        </ul>
      </>,
      <>
        <b>Step 2: Complete New Provider Orientation – Level I (NPO L1)</b>
        <br />

        <ul>
          <li>
            A self-paced, online training through the Adobe Learning Management
            (ALM) System.
          </li>
          <li>
            Required for the Executive Director (or equivalent) prior to
            application submission.
          </li>
          <li>Upon completion, receive access to the Certification Packet.</li>
        </ul>
      </>,
      <>
        <b>Step 3: Submit Certification Packet</b>
        <br />
        Send to{" "}
        <a href="mailto:1915iRISEprovider@ky.gov">1915iRISEprovider@ky.gov</a>:
        <ul>
          <li>Proof of New Provider Orientation Level I completion.</li>
          <li>Selected services checklist.</li>
          <li>Licenses, certifications, and agency documents.</li>
          <li>
            Internal policies for quality, confidentiality, and incident
            reporting.
          </li>
        </ul>
      </>,
      <>
        <b>Step 4: Initial Review (10 Business Days)</b>
        <br />
        DBHDID will issue one of three decisions:
        <ul>
          <li>
            Approved for Certification Review (advance to New Provider
            Orientation Level 2).
          </li>
          <li>Resubmission Required.</li>
          <li>Not Eligible.</li>
        </ul>
      </>,
      <>
        <b>Step 5: Complete New Provider Orientation – Level II (NPO L2)</b>
        <br />
        <ul>
          <li>Second-level online training for leadership.</li>
          <li>
            Covers Health Insurance Portability and Accountability Act (HIPAA),
            Medicaid billing, Person-Centered Service Plans (PCSPs) development,
            and participant rights.
          </li>
          <li>Proof of completion required to advance.</li>
        </ul>
      </>,
      <>
        <b>Step 6: Pre-Service Review</b>
        <br />
        DBHDID staff will evaluate:
        <ul>
          <li>Policy and procedure compliance.</li>
          <li>Staff credentials.</li>
          <li>Service descriptions and documentation readiness.</li>
        </ul>
      </>,
      <>
        <b>Step 7: On-Site Review</b>
        <br />
        DBHDID will conduct an on-site review to:
        <ul>
          <li>Inspect facilities (if applicable).</li>
          <li>Verify operational readiness.</li>
          <li>Review training records.</li>
        </ul>
      </>,
      <>
        <b>Step 8: Certification Decision</b>
        Providers will receive:
        <ul>
          <li>
            <b>Certification Letter</b> (if approved).
          </li>
          <li>OR a denial or resubmission request.</li>
        </ul>
      </>,
      <>
        <b>Step 9: Medicaid (MPPA) and Provider Intake System Enrollment</b>
        <br />
        Submit application via the <b>MPPA</b> with your certification letter.
        Enrollment is not complete until approved by the Department for Medicaid
        Services (DMS). Enroll in <b>Therap Provider Intake System</b> upon
        certification.
      </>,
      <>
        <b>Step 10: Staff Training and Service Launch</b>
        <br />
        All staff must complete:
        <ul>
          <li>
            <b>Phase I Training</b> before providing services.
          </li>
          <li>
            <b>Phase II Training</b> within six months of employment.
          </li>
          <li>
            <b>Phase III Training</b> as applicable (service-specific).
          </li>
        </ul>
      </>,
      <>
        <b>Step 11: Ongoing Monitoring and Re-Certification</b>
        <br />
        <li>Providers must re-certify every two years.</li>
        <li>Participate in site visits, audits, and quality reviews.</li>
        <li>Maintain compliance with documentation and training standards.</li>
      </>,
      <>
        <b>Training and Technical Assistance</b>
        <br />
        The Kentucky Cabinet for Health and Family Services (CHFS), DBHDID, and
        DMS provide training and support to all 1915(i) RISE-certified
        providers, including:
        <ul>
          <li>Web-based training modules (ALM system).</li>
          <li>Job aids and certification checklists.</li>
          <li>Recorded and live webinars.</li>
          <li>
            Billing and claims office hours in partnership with Gainwell
            Technologies.
          </li>
          <li>
            One-on-one technical assistance for onboarding and documentation.
          </li>
        </ul>
      </>,
      <>
        <b>Provider Responsibilities</b>
        <br />
        1915(i) RISE providers must:
        <ul>
          <li>Adhere to service standards and documentation policies.</li>
          <li>Deliver services as defined in each participant’s PCSP.</li>
          <li>Maintain up-to-date staff training and licensure.</li>
          <li>Submit accurate, timely claims to Medicaid.</li>
          <li>Cooperate with audits and corrective action requests.</li>
          <li>Ensure participant rights and maintain confidentiality.</li>
        </ul>
      </>,
      <>
        <b>Contact Information</b>
        <br />
        For certification questions, training help, or to submit materials:
        <b>Email:</b>
        <a href="mailto:1915iRISEprovider@ky.gov ">1915iRISEprovider@ky.gov </a>
      </>,
      <>
        For MPPA enrollment or billing support: <br />
        <ul>
          <li>
            <b>Visit:</b>
            <a href="https://medicaidsystems.ky.gov/Partnerportal/home.aspx">
              https://medicaidsystems.ky.gov/Partnerportal/home.aspx
            </a>
          </li>
          <li>
            <b>Contact:</b> Gainwell Technologies or the DMS Provider Enrollment
            Team
          </li>
        </ul>
        <br />
        <br />
        <b>Related Resources-</b>
        <br />
        <a href="/1915iriseinitiative-provider-faq">
          1915(i) RISE Initiative Provider FAQ{" "}
        </a>
      </>,
    ],
  },
];

export default LittleEyeProvider_Content;
